const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userId: state => state.user.userId,
  roles: state => state.user.roles,
  hospitals: state => state.user.hospitals,
  departId: state => state.user.departId,
  voiceNotify: state => state.user.voiceNotify, // 是否开启语音提醒(有新的待写报告)
  voiceNotifyFinishedReport: state => state.user.voiceNotifyFinishedReport, // 是否开启报告完成的语音提醒
  pwdErrorTime: state => state.user.pwdErrorTime,
  dict: state => state.user.dict,
  currentUserRoleDepart: state => state.user.currentUserRoleDepart,
  userInfo: state => state.user.userInfo,
  writeReportList: state => state.diagnostic.list,
  lock: state => state.diagnostic.lock,
  ReportListtotalCount: state => state.diagnostic.totalCount,
  printInfo: state => state.diagnostic.printInfo,
  bodyparts: state => state.diagnostic.bodypart,
  doctorList: state => state.diagnostic.doctorList,
  devices: state => state.diagnostic.device,
  recordList: state => state.diagnostic.RecordList,
  recordPatient: state => state.diagnostic.RecordPatient,
  patientReportList: state => state.diagnostic.patientReportList,
  patientInfo: state => state.diagnostic.patientInfo,
  savereportstatus: state => state.diagnostic.savereportstatus,
  savemodulestatus: state => state.diagnostic.savereportstatus,
  renounceSavestatus: state => state.diagnostic.savereportstatus,
  templates: state => state.diagnostic.templates,
  selftemplates: state => state.diagnostic.selftemplates,
  ReportVariable: state => state.diagnostic.ReportVariable,
  printList: state => state.diagnostic.printList,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  departments: state => state.register.departments, // 申请科室字典
  HisRegisterList: state => state.register.HisRegisterList,
  checkBody: state => state.register.checkBody, // 检查部位字典
  checkProject: state => state.register.checkProject, // 检查项目字典
  checkList: state => state.register.checkList, // 登记检查信息（设备，部位，项目）
  // checkBody: state => state.register.checkBody, // 检查部位字典
  // checkProject: state => state.register.checkProject, // 检查项目字典
  imageRoom: state => state.register.imageRoom, // 影像室字典
  imageRoomList: state => state.register.imageRoomList, // 影像室字典
  registerList: state => state.register.registerList, // 登记管理列表
  regpatient: state => state.register.regpatient, // 患者详情
  PerformList: state => state.screeing.PerformList, // 执行单列表
  PerformListtotalCount: state => state.screeing.PerformListtotalCount, // 执行单列表t
  medicalStatus: state => state.screeing.medicalStatus, // 医疗状态
  UpdateProcedure: state => state.screeing.UpdateProcedure, // 开始检查
  imgList: state => state.screeing.imgList, // 影像列表
  dashboard: state => state.dashboards.dashboard,
  statistics: state => state.dashboards.statistics, // 统计数据
  proceduresStatistic: state => state.dashboards.proceduresStatistic, // 获取按时间统计检查数
  AvgMinsStatistic: state => state.dashboards.AvgMinsStatistic, // 获取按时间统计平均诊断时间
  hosPitalPercentage: state => state.dashboards.hosPitalPercentage, // 获取各医院占比
  patients: state => state.register.patients, // 患者详情
  DoctorSchcedule: state => state.setting.DoctorSchcedule, // 医生排版表
  modalityTypes: state => state.setting.modalityTypes, // 模态类型
  ProcedureCodes: state => state.setting.ProcedureCodes, // 模态类型
  ModuleList: state => state.setting.ModuleList, // 模态类型
  RoleList: state => state.setting.RoleList, // 模态类型
  UserList: state => state.setting.UserList, // 模态类型
  hospitalInfo: state => state.setting.hospitalInfo,
  headerList: state => state.diagnostic.headerList, // 列表头
  DiaDeparts: state => state.diagnostic.DiaDeparts, // 获取当前科室的可分配科室
  doctorsWork: state => state.statistic.doctorsWork, // 统计医生
  deviceWork: state => state.statistic.deviceWork, // 统计设备量
  hospWork: state => state.statistic.hospWork, // 统计医院量,
  watchObj: state => state.statistic.watchObj, // 统计图表监听,
  crdoctorsWork: state => state.statistic.crdoctorsWork, // 统计图表监听,
  apdoctorsWork: state => state.statistic.apdoctorsWork, // 统计图表监听,
  hospWorkpi: state => state.statistic.hospWorkpi, // 统计图表监听,
  selfDepartPositiveRate: state => state.statistic.selfDeaprtPoaitiveRate, // 本科室阳性率数据
  selfDeaprtPoaitiveRatePI: state => state.statistic.selfDeaprtPoaitiveRatePI, // 本科室阳性率数据
  searchReport: state => state.diagnostic.searchReport,
  search: state => state.diagnostic.search
}
export default getters
